<script setup>
definePage({
  meta: {
    layout: "default",
  },
});

const pageTitle = "Import By Mall";

const userData = useCookie("userData").value
  ? useCookie("userData").value.user
  : null;

const mallId = ref(userData ? userData.mallId : null);

const navigationTab = ref("By User");
const tabItems = [
  "User",
  "Card Holder",
  "Card",
  "Merchant",
  "Shop",
  "Location",
  "Transaction History",
];
</script>

<template>
  <h2 class="text-h2 my-4">{{ pageTitle }}</h2>
  <h4 class="text-h4 my-4">Mall Id : {{ mallId }}</h4>
  <VCard></VCard>
  <VTabs v-model="navigationTab" class="mb-5">
    <VTab v-for="item in tabItems" :key="item">
      {{ item }}
    </VTab>
  </VTabs>
  <VWindow v-model="navigationTab">
    <VWindowItem :key="tabItems[0]">
      <ImportByUser :mallId="mallId" />
    </VWindowItem>
    <VWindowItem :key="tabItems[1]">
      <ImportByCardHolder :mallId="mallId" />
    </VWindowItem>
    <VWindowItem :key="tabItems[2]">
      <ImportByCard :mallId="mallId" />
    </VWindowItem>
    <VWindowItem :key="tabItems[3]">
      <ImportByMerchant :mallId="mallId" />
    </VWindowItem>
    <VWindowItem :key="tabItems[4]">
      <ImportByShop :mallId="mallId" />
    </VWindowItem>
    <VWindowItem :key="tabItems[5]">
      <ImportByLocation :mallId="mallId" />
    </VWindowItem>
    <VWindowItem :key="tabItems[6]">
      <ImportByTransactionHistory :mallId="mallId" />
    </VWindowItem>
  </VWindow>
</template>
